import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';

import CountrySearchInput from '../CountrySearchInput/CountrySearchInput';

import styles from './CountrySearchInputWithResults.module.scss';
import Props from './CountrySearchInputWithResults.props';

const CountrySearchInputWithResults = ({ results, onSelect, className, ...otherProps }: Props) => {
  const RenderResultsList = () => {
    return results?.map((result) => (
      <div
        key={result._id}
        className={cn(styles.Result, {
          [styles.Selected]: result.selected,
        })}
        onClick={() => onSelect(result)}>
        {result.title}
        {result.isLoading && <FontAwesomeIcon icon={faSpinnerThird} className={styles.Loader} />}
        {!result.isLoading && result.selected && (
          <FontAwesomeIcon icon={faCheck} className={styles.Selected} />
        )}
      </div>
    ));
  };

  return (
    <div className={cn(styles.CountrySearchInputWithResults, className)}>
      <CountrySearchInput {...otherProps} />
      {results.length > 0 && <div className={styles.ResultsList}>{RenderResultsList()}</div>}
    </div>
  );
};

export default observer(CountrySearchInputWithResults);
